import script from "./TcCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./TcCheck.vue?vue&type=script&setup=true&lang=js"

import "./TcCheck.vue?vue&type=style&index=0&id=97dc421c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97dc421c"]])

export default __exports__